module.exports = __webpack_public_path__ + "static/img/part4.d5d64e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/part4.png
// module id = s/N1
// module chunks = 0